module.exports = __webpack_public_path__ + "web/img/logo-wit.790902f2.png";